import styled from 'styled-components';
import colors from '@monorepo-zazuu/shared/constants/colors';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const Badge = styled.span<{ isFirstPurchase: boolean; $direction: 'horizontal' | 'vertical' }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.6rem;
  border-radius: 10rem;
  background-color: ${(props) =>
    props.isFirstPurchase ? colors.zazuu.purple400 : colors.primary.default};
  color: ${colors.gray.white};
  font-family: 'Manrope', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  white-space: nowrap;
  cursor: default;

  ${(props) =>
    props.$direction === 'vertical' &&
    `
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(180deg);
    padding: 1rem 0.4rem;
  `}
`;

interface ITooltipPos {
  top: number;
  left: number;
  placement: 'top' | 'bottom';
}

export const Tooltip = styled.div<{ layout: 'row' | 'column'; $pos: ITooltipPos }>`
  position: fixed;
  top: ${(props) => (props.$pos.placement === 'bottom' ? `${props.$pos.top}px` : 'auto')};
  bottom: ${(props) => (props.$pos.placement === 'top' ? `calc(100vh - ${props.$pos.top}px)` : 'auto')};
  left: ${(props) => `${props.$pos.left}px`};
  transform: translateX(-50%);
  background-color: ${colors.gray.dark01};
  color: ${colors.gray.white};
  font-family: 'Open Sans', sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  padding: 1rem 1.2rem;
  border-radius: 0.4rem;
  z-index: 9999;
  pointer-events: none;
  writing-mode: horizontal-tb;
  text-orientation: mixed;

  display: flex;
  flex-direction: ${(props) => (props.layout === 'row' ? 'row' : 'column')};
  flex-wrap: ${(props) => (props.layout === 'row' ? 'wrap' : 'nowrap')};
  gap: ${(props) => (props.layout === 'row' ? '0.4rem 1.2rem' : '0')};
  min-width: ${(props) => (props.layout === 'row' ? '30rem' : '20rem')};
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    ${(props) => props.$pos.placement === 'top' ? 'top: 100%;' : 'bottom: 100%;'}
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    ${(props) => props.$pos.placement === 'top'
      ? `border-top-color: ${colors.gray.dark01};`
      : `border-bottom-color: ${colors.gray.dark01};`}
  }
`;

export const TooltipRow = styled.div<{ layout: 'row' | 'column' }>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props.layout === 'row' ? '0.4rem' : '1.6rem')};
  justify-content: ${(props) => (props.layout === 'row' ? 'flex-start' : 'space-between')};
  line-height: 1.8;
  margin-bottom: ${(props) => (props.layout === 'column' ? '0.4rem' : '0')};

  span:first-child {
    color: ${colors.gray.dark03};
    font-size: 1.1rem;
  }

  span:last-child {
    font-weight: 600;
  }
`;

export const TooltipDivider = styled.hr`
  border: none;
  border-top: 1px solid ${colors.gray.dark02};
  margin: 0.6rem 0;
  width: 100%;
`;
